export default "__VITE_ASSET__2ae7eb7d__"